import React, { Component } from 'react';

import LangSelector from './LangSelector'

import pootsyLogo from '../static/img/pootsy-logo.png'

class LandingNav extends Component {
	render() {
		let { links } = this.props
		return (
			<div className="LandingNav">
				<img className="logo" alt="logo" src={pootsyLogo}/>
				<LangSelector/>
				<div className="nav-items">
					{links.map((link, index) =>
						<div key={index} className="nav-item">{link}</div>
					)}
				</div>
			</div>
		);
	}
}

export default LandingNav;
LandingNav.defaultProps = { links: [] }



// WEBPACK FOOTER //
// ./src/components/LandingNav.js